"use client";

import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import { motion } from "motion/react";
import {
  PostHostEventsEnum,
  sendPostHogEvent,
} from "../../../libs/post-hog/post-hog-send-event";

interface NewsletterCTAConfig {
  type: "newsletter";
  fields: string[];
  buttonText: string;
  successMessage: string;
  modal: {
    title: string;
    description: string;
    agreement: string;
  };
}

export default function NewsletterCTABlock({
  config,
}: {
  config: NewsletterCTAConfig;
}) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [formData, setFormData] = useState<Record<string, string>>({});
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      ReactModal.setAppElement(document.body);
    }
  }, []);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setModalIsOpen(false);
        setSuccess(false);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    sendPostHogEvent({
      eventName: PostHostEventsEnum.NEWSLETTER_SUBSCRIBED,
      email: formData.email,
      identifyProperties: { ...formData },
      eventProperties: { ...formData },
    });

    setSuccess(true);
  };

  return (
    <div className="cta-block">
      <button className="cta-button" onClick={() => setModalIsOpen(true)}>
        <span>{config.buttonText}</span>
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => {
          setModalIsOpen(false);
          setSuccess(false);
        }}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            zIndex: 1000,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            maxWidth: "500px",
            width: "90%",
            borderRadius: "12px",
            padding: "2rem",
          },
        }}
      >
        <h2 className="modal-title">{config.modal.title}</h2>
        <p className="modal-description">{config.modal.description}</p>

        {success && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            style={{
              width: "100%",
              backgroundColor: "rgb(98, 168, 229)",
              color: "white",
              textAlign: "center",
              padding: "5px",
              borderRadius: "12px",
              marginBottom: "1.5rem",
            }}
          >
            <p
              style={{
                fontSize: ".8rem",
                fontWeight: 600,
                margin: 0,
              }}
            >
              Salvo com sucesso!
            </p>
          </motion.div>
        )}

        <form onSubmit={handleSubmit} className="cta-form">
          {config.fields.map((field) => (
            <input
              key={field}
              name={field}
              type={field === "email" ? "email" : "text"}
              placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
              onChange={handleChange}
              required
              className="form-input"
            />
          ))}

          <div className="agreement-text">*{config.modal.agreement}</div>

          <div className="form-actions">
            {/* <button type="button" onClick={() => setModalIsOpen(false)}>
              <span>Cancelar</span>
            </button> */}
            <button type="submit">
              <span>{config.buttonText}</span>
            </button>
          </div>
        </form>
      </ReactModal>
    </div>
  );
}
